export const randomWindowVariableKey = '__frontend_utils_consistent_random';
export function consistentRandomNumber() {
    if (window[randomWindowVariableKey]) {
        return window[randomWindowVariableKey];
    }
    window[randomWindowVariableKey] = Math.random();
    return window[randomWindowVariableKey];
}
